import { Route } from "react-router-dom";
import React, { lazy } from "react";
import { MOBILE_ROUTES, ROUTES } from "../../mobile-routes";
import { JobDescriptionRequestManagement } from "@pages/JobDescriptionRequest/JobDescriptionRequestManagement";
import { OrderRegisterManagement } from "@pages/order-change-request/order-register-managment";
import { JobDescriptionLists } from "app/pages/HrJobDescription/job-description-list";
import {
  PortalFeedbackQuestionsListManagement,
} from "@pages/PortalFeedbackQuestions/PortalFeedBackQuestionsListManagement";
import {
  PortalIncomingFeedbackQuestionsManagement,
} from "@pages/PortalFeedbackQuestions/PortalIncomingFeedbackQuestionsManagement";
import { QuestionsItemManagement } from "@pages/PortalFeedbackQuestions/QuestionsItemManagement";

const PersonExperience = lazy(() => import("../../pages/PersonAssignment/PersonAssignmentList"));
const NutritionBalanceManagement = lazy(() =>
  import("../../pages/nutrition-balance/NutritionBalanceManagement").then(module => ({
    default: module.NutritionBalanceManagement,
  })),
);
const ManagerAbsenceBalance = lazy(() =>
  import("../../pages/Absence/manager-absence-balance").then(module => ({
    default: module.ManagerAbsenceBalance,
  })),
);

export const EXCLUDE_METADATA_ROUTES = [
  "experience",
  "absence",
  "nutritionBalance",
  "kpi",
];

export const SimpleMobileRoutes = [
  <Route
    exact={true}
    path={"/" + MOBILE_ROUTES.personAssignmentList}
    component={PersonExperience}
    key={"PersonExperience"}
  />,
  <Route
    exact={true}
    path={"/" + MOBILE_ROUTES.absenceBalance}
    component={ManagerAbsenceBalance}
    key={"ManagerAbsenceBalance"}
  />,
  <Route
    exact={true}
    path={"/" + ROUTES.nutritionBalance.mobile}
    component={NutritionBalanceManagement}
    key={"NutritionBalanceManagement"}
  />,
  <Route
    exact={true}
    path={"/" + ROUTES.jobDescriptionList.mobile}
    component={JobDescriptionLists}
    key={"JobDescriptionRequestManagementList"}
  />,
  <Route
    exact={true}
    path={"/" + ROUTES.orderRegisterSheet.mobile}
    component={OrderRegisterManagement}
    key={"OrderRegisterManagement"}
  />,
  <Route
    exact={true}
    path={"/" + ROUTES.jobDescriptionRequest.mobile}
    component={JobDescriptionRequestManagement}
    key={"JobDescriptionRequestManagementRequest"}
  />,

  // feedbackQuestions

  <Route
    exact={true}
    path={"/" + ROUTES.portalFeedbackQuestionsList.mobile}
    component={PortalFeedbackQuestionsListManagement}
    key={"portalFeedbackQuestionsList"}
  />,
  <Route
    exact={true}
    path={"/" + ROUTES.portalIncomingFeedbackQuestions.mobile}
    component={PortalIncomingFeedbackQuestionsManagement}
    key={"portalIncomingFeedbackQuestions"}
  />,
  <Route
    exact={true}
    path={"/" + ROUTES.portalQuestionsItem.mobile}
    component={QuestionsItemManagement}
    key={"portalQuestionsItem"}
  />,
];
